module.exports = __webpack_public_path__ + "img/poster-regles.70f5a953.jpg";